import RequestStatus from 'types/general/requests/RequestStatus';
import ELookupAPIKeys from 'types/backend_models/lookup_status/ELookupAPIKeys';
import { IDefaultRequestProps } from 'types/general/GeneralStateModelInterfaces';
import ILookupModel from 'types/backend_models/lookup_status/ILookupModel';
import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

/* DEFAULT STATE & TYPES */
export interface ILookupStateModel extends IDefaultRequestProps {
    data: ILookupModel[] | null
}

type TLookupDataState = {
    [ELookupAPIKeys.documentTypes]: ILookupStateModel,
    [ELookupAPIKeys.documentOwnerTypes]: ILookupStateModel,
    [ELookupAPIKeys.unitOfMeasure]: ILookupStateModel
}

const defaultState: TLookupDataState = {
    [ELookupAPIKeys.documentTypes]: { requestStatus: RequestStatus.idle, data: null, error: null },
    [ELookupAPIKeys.documentOwnerTypes]: { requestStatus: RequestStatus.idle, data: null, error: null },
    [ELookupAPIKeys.unitOfMeasure]: { requestStatus: RequestStatus.idle, data: null, error: null }
}

/* REDUCERS */
const setFetchLookupPendingReducer: CaseReducer<TLookupDataState, PayloadAction<{ lookupKey: ELookupAPIKeys }>> = (state: TLookupDataState, action) => {
    let lookupObject = state[action.payload.lookupKey];
    lookupObject.data = null;
    lookupObject.requestStatus = RequestStatus.pending;
    lookupObject.error = null;
}
const setFetchLookupSuccesReducer: CaseReducer<TLookupDataState, PayloadAction<{ data: ILookupModel[], lookupKey: ELookupAPIKeys }>> = (state: TLookupDataState, action) => {
    let lookupObject = state[action.payload.lookupKey];
    lookupObject.data = action.payload.data;
    lookupObject.requestStatus = RequestStatus.succes;
}
const setFetchLookupErrorReducer: CaseReducer<TLookupDataState, PayloadAction<{ lookupKey: ELookupAPIKeys, error: string }>> = (state: TLookupDataState, action) => {
    let lookupObject = state[action.payload.lookupKey];
    lookupObject.data = null;
    lookupObject.error = action.payload.error;
    lookupObject.requestStatus = RequestStatus.error;
}

/* SLICE */
const lookupDataSlice = createSlice({
    name: "lookupData",
    initialState: defaultState,
    reducers: {
        setFetchLookupPending: setFetchLookupPendingReducer,
        setFetchLookupSucces: setFetchLookupSuccesReducer,
        setFetchLookupError: setFetchLookupErrorReducer
    }
});

export const {
    setFetchLookupPending,
    setFetchLookupSucces,
    setFetchLookupError
} = lookupDataSlice.actions;

export default lookupDataSlice.reducer;

/*  OLD REDUCER
function lookupDataReducer(state = defaultState, action: TLookupDataActionTypes): ILookupDataState {
    switch (action.type) {
        case FETCH_LOOKUP_PENDING: {
            return {
                ...state,
                [action.lookupAPIKey]: {
                    requestStatus: RequestStatus.pending,
                    data: null
                }
            }
        }
        case FETCH_LOOKUP_SUCCESS: {
            return {
                ...state,
                [action.lookupAPIKey]: {
                    requestStatus: RequestStatus.succes,
                    data: action.data.sort(Shared.Formatters.dynamicSort("sortOrder"))
                }
            }
        }
        case FETCH_LOOKUP_ERROR: {
            return {
                ...state,
                [action.lookupAPIKey]: {
                    requestStatus: RequestStatus.error,
                    data: null
                }
            }
        }
        default: {
            return state;
        }
    }
}

export default lookupDataReducer;
*/